/**
 * 检测是否为移动设备（客户端版本）
 * @returns {boolean} 如果是移动设备则返回true，否则返回false
 */
export function isMobileDevice(): boolean {
  if (typeof window !== 'undefined' && typeof navigator !== 'undefined') {
    const userAgent = navigator.userAgent;
    const mobileRegex =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i;

    return mobileRegex.test(userAgent);
  }

  // 默认返回false
  return false;
}
